import React, { FC, PropsWithChildren } from 'react'
import { Background, Modal } from 'styles/modals'

type StandardProps = {
  closeModal: () => void
  disableClose?: boolean
}

const Standard: FC<PropsWithChildren<StandardProps>> = ({ children, closeModal, disableClose }) => {
  const handleClose = () => {
    if (disableClose) {
      return
    }
    closeModal()
  }

  return (
    <>
      <Background onClick={handleClose} />
      <Modal data-type='modal'>{children}</Modal>
    </>
  )
}

export default Standard
